// import React from "react";
// import storesData from "../../data/data.json";

// const StoreTemplate = ({ pageContext }) => {
//   const { storeId } = pageContext; // This will be passed from Gatsby's page creation process

//   // You can fetch store-specific data using GraphQL queries or any other method
//   // For demonstration purposes, let's assume you have a list of stores

//   // Find the store based on the storeId
// const store = storesData.find((store) => store.id === storeId);

//   return (
//     <div>
//       <h1>{store.itemName}</h1>
//       <p>{store.itemNumber}</p>
//     </div>
//   );
// };

// export default StoreTemplate;

import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import NavBar from "../../components/Header/PRODUCT-RANGE";
import Footer from "../../components/footer";
import Sidebar from "../../components/sidebar";
import storesData from "../../data/data.json";
import ZoomImage from "./ZoomImage";
import Enquiry from "./enquiry";
import "../../styling/pages.css";
import "../../styling/templates.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

export default function Product({ pageContext }) {
  const { storeId } = pageContext;

  // Find the current store
  const store = storesData.find((store) => store.id === storeId);

  let store1, store2, store3, store4, store5;

  if (store) {
    // Find the store with itemID one less than the current store's itemID
    store1 = storesData.find((s) => s.itemID === store.itemID - 1);

    // Find the store with itemID one more than the current store's itemID
    store2 = storesData.find((s) => s.itemID === store.itemID + 1);

    // Find the store with itemID two more than the current store's itemID
    store3 = storesData.find((s) => s.itemID === store.itemID + 2);

    // Find the store with itemID three more than the current store's itemID
    store4 = storesData.find((s) => s.itemID === store.itemID + 3);

    // Find the store with itemID four more than the current store's itemID
    store5 = storesData.find((s) => s.itemID === store.itemID + 4);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [showForm, setShowForm] = useState(false);

  const toggleFormVisibility = () => {
    setShowForm(!showForm);
  };

  const Card = (props) => {
    return (
      <div className="store-card">
        <div>
          <a href={props.href}>
            <img src={props.image} alt={props.title} className="card-image" />
          </a>
          <p className="store-para">{props.itemName}</p>
          <a href={props.href}>
            <h2 className="store-h2">
              {props.itemNumber.replace(/<br\s*\/?>/g, " ")}
            </h2>
          </a>
          <div className="store-card-btn-template">
            <a
              href={props.href}
              className="btn btn-secondary btn-lg"
              type="button"
              style={{
                backgroundColor: "#f4f4f4",
                color: "#000",
                padding: "15px",
                paddingLeft: "20px",
                paddingRight: "20px",
                fontFamily: "AvenirLTStd-Book, sans-serif",
                fontWeight: "700",
                fontSize: "15px",
                lineHeight: "20px",
                textDecoration: "none",
                border: "none",
                marginLeft: "-5px",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#000000";
                e.target.style.color = "#ffffff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#f4f4f4";
                e.target.style.color = "#000000";
              }}
            >
              {props.button}
            </a>
          </div>
        </div>
      </div>
    );
  };

  const cards = [
    {
      image: store2?.image || storesData[0].image,
      button: "Read more",
      itemName: store2?.itemName || storesData[0].itemName,
      itemNumber: store2?.itemNumber || storesData[0].itemNumber,
      href: `/product/${encodeURIComponent(store2?.id || storesData[0].id)}/`,
    },
    {
      image: store3?.image || storesData[1].image,
      button: "Read more",
      itemName: store3?.itemName || storesData[1].itemName,
      itemNumber: store3?.itemNumber || storesData[1].itemNumber,
      href: `/product/${encodeURIComponent(store3?.id || storesData[1].id)}/`,
    },
    {
      image: store4?.image || storesData[2].image,
      button: "Read more",
      itemName: store4?.itemName || storesData[2].itemName,
      itemNumber: store4?.itemNumber || storesData[2].itemNumber,
      href: `/product/${encodeURIComponent(store4?.id || storesData[2].id)}/`,
    },
    {
      image: store5?.image || storesData[3].image,
      button: "Read more",
      itemName: store5?.itemName || storesData[3].itemName,
      itemNumber: store5?.itemNumber || storesData[3].itemNumber,
      href: `/product/${encodeURIComponent(store5?.id || storesData[3].id)}/`,
    },
  ];

  // Meta Data
  const cardID = storesData.find((store) => store.id === storeId);
  const itemID = cardID ? cardID.id : ""; // Get the itemID

  const cardNum = storesData.find((store) => store.id === storeId);
  const itemNum = cardNum ? cardNum.itemNumber : ""; // Get the itemNumber

  const cardDes = storesData.find((store) => store.id === storeId);
  const itemDes = cardDes ? cardDes.itemDetails : ""; // Get the itemDetails

  const metaTitleData = storesData.find((store) => store.id === storeId);
  const metaTitle = metaTitleData ? metaTitleData.metaTitle : ""; // Get the metaTitle

  const metaDesData = storesData.find((store) => store.id === storeId);
  const metaDescription = metaDesData ? metaDesData.metaDescription : ""; // Get the metaTitle

  return (
    <div>
      <Helmet>
        <title>{`${metaTitle}`}</title>
        <meta name="title" content={`${metaTitle} `} />
        <meta name="description" content={`${metaDescription}`} />
        <link
          rel="canonical"
          href={`https://www.beirabrush.com/product/${itemID}/`}
        />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content={`You searched for "${itemNum}" - Beira Brush`}
        />
        <meta
          property="og:url"
          content={`https://www.beirabrush.com/product/${itemID}/`}
        />
        <meta
          property="og:image"
          content="https://www.beirabrush.com/wp-content/uploads/2021/06/Beira-Brush-3.jpg"
        />
      </Helmet>
      <NavBar />

      <div className="store-pc">
        <center>
          <div className="store">
            <div style={{ marginTop: "20px", marginBottom: "60px" }}>
              {/* <ImageSlider /> */}
            </div>

            <table
              style={{
                width: "100%",
                textAlign: "start",
                marginBottom: "30px",
              }}
            >
              <tr>
                <td style={{ width: "276px", verticalAlign: "top" }}>
                  <Sidebar />
                </td>
                <td style={{ width: "1px", backgroundColor: "#f4f4f4" }}></td>
                <td style={{ width: "60px" }}></td>
                <td style={{ width: "auto", verticalAlign: "top" }}>
                  <div>
                    <table style={{ width: "100%", textAlign: "start" }}>
                      <tr>
                        <td style={{ width: "39%", verticalAlign: "top" }}>
                          <div style={{ marginRight: "-30px" }}>
                            <ZoomImage
                              imageUrl1={store?.image1 || store?.image}
                              imageUrl2={store?.image2}
                              imageUrl3={store?.image3}
                              imageUrl4={store?.image4}
                              imageUrl5={store?.image5}
                              imageUrl6={store?.image6}
                              imageUrl7={store?.image7}
                              imageUrl8={store?.image8}
                              itemNumber={store?.itemNumber}
                            />

                            {/* <ZoomImage
                              imageUrl1={
                                store?.innerImage
                                  ? store.innerImage
                                  : store?.image
                              }
                            /> */}
                          </div>
                        </td>
                        <td style={{ width: "5%", verticalAlign: "top" }}></td>
                        <td style={{ width: "auto", verticalAlign: "top" }}>
                          <div style={{ marginLeft: "30px" }}>
                            <h2
                              style={{ width: "75%" }}
                              className="read-more-topic"
                              dangerouslySetInnerHTML={{
                                __html: store?.itemNumber,
                              }}
                            ></h2>
                          </div>
                          <div style={{ marginRight: "20px" }}>
                            <div className="arrow-button-read-more">
                              <a
                                href={`/product/${
                                  store1?.id ||
                                  storesData[storesData.length - 1].id
                                }/`}
                              >
                                <button
                                  type="button"
                                  class="btn btn-custom btn-sm"
                                >
                                  <FontAwesomeIcon icon={faChevronLeft} />
                                </button>
                              </a>
                              &nbsp;&nbsp;
                              <a
                                href={`/product/${
                                  store2?.id || storesData[0].id
                                }/`}
                              >
                                <button
                                  type="button"
                                  class="btn btn-custom btn-sm"
                                >
                                  <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                              </a>
                            </div>
                          </div>
                          <div className="read-more-para">
                            <div
                              style={{
                                marginLeft: "30px",
                                marginRight: "20px",
                              }}
                            >
                              {store?.itemName === "Tip Top" && (
                                <ul
                                  style={{
                                    paddingLeft: "20px",
                                    listStyleType: "disc",
                                  }}
                                >
                                  {store?.itemDetails && (
                                    <li>{store.itemDetails}</li>
                                  )}
                                  {store?.itemDetails2 && (
                                    <li>{store.itemDetails2}</li>
                                  )}
                                  {store?.itemDetails3 && (
                                    <li>{store.itemDetails3}</li>
                                  )}
                                  {store?.itemDetails4 && (
                                    <li>{store.itemDetails4}</li>
                                  )}
                                  {store?.itemDetails5 && (
                                    <li>{store.itemDetails5}</li>
                                  )}
                                  {store?.itemDetails6 && (
                                    <li>{store.itemDetails6}</li>
                                  )}
                                  {store?.itemDetails7 && (
                                    <li>{store.itemDetails7}</li>
                                  )}
                                  {store?.itemDetails8 && (
                                    <li>{store.itemDetails8}</li>
                                  )}
                                  {store?.itemDetails9 && (
                                    <li>{store.itemDetails9}</li>
                                  )}
                                  {store?.itemDetails10 && (
                                    <li>{store.itemDetails10}</li>
                                  )}
                                </ul>
                              )}

                              {store?.itemName !== "Tip Top" && (
                                <>
                                  {store?.itemDetails}
                                  {store?.itemDetails2 && <br />}
                                  {store?.itemDetails2}
                                  {store?.itemDetails3 && <br />}
                                  {store?.itemDetails3}
                                  {store?.itemDetails4 && <br />}
                                  {store?.itemDetails4}
                                  {store?.itemDetails5 && <br />}
                                  {store?.itemDetails5}
                                  {store?.itemDetails6 && <br />}
                                  {store?.itemDetails6}
                                  {store?.itemDetails7 && <br />}
                                  {store?.itemDetails7}
                                  {store?.itemDetails8 && <br />}
                                  {store?.itemDetails8}
                                  {store?.itemDetails9 && <br />}
                                  {store?.itemDetails9}
                                  {store?.itemDetails10 && <br />}
                                  {store?.itemDetails10}
                                </>
                              )}
                            </div>
                          </div>

                          <div
                            style={{ marginLeft: "30px", marginRight: "20px" }}
                          >
                            {store?.itemName === "Tip Top" && (
                              // <>
                              //   <h3>Colours</h3>
                              //   <div
                              //     style={{
                              //       display: "flex",
                              //       gap: "10px",
                              //       marginLeft: "10px",
                              //     }}
                              //   >
                              //     {/* Adding colors manually */}
                              //     <div
                              //       style={{
                              //         width: "40px",
                              //         height: "40px",
                              //         backgroundColor: "red",
                              //       }}
                              //     ></div>
                              //     <div
                              //       style={{
                              //         width: "40px",
                              //         height: "40px",
                              //         backgroundColor: "blue",
                              //       }}
                              //     ></div>
                              //     <div
                              //       style={{
                              //         width: "40px",
                              //         height: "40px",
                              //         backgroundColor: "green",
                              //       }}
                              //     ></div>
                              //   </div>
                              //   <br />
                              //   <h3>Buy Online</h3>
                              //   <div
                              //     style={{
                              //       marginLeft: "10px",
                              //     }}
                              //   >
                              //     <div className="buy-online-grid-container">
                              //       <div className="buy-online-grid-item">
                              //         <a
                              //           href="https://lassana.com/?gad_source=1&gclid=CjwKCAiAudG5BhAREiwAWMlSjE8Chw07ZUOVxNojGVOKkmd2YCgGuR-sc1vxeqdL-sQ064Y1iMPmeRoCBAQQAvD_BwE"
                              //           target="_blank"
                              //           rel="noopener noreferrer"
                              //         >
                              //           <img
                              //             src="/images/new-item/buy-online-1.png"
                              //             alt=""
                              //           />
                              //         </a>
                              //       </div>
                              //       <div className="buy-online-grid-item">
                              //         <a
                              //           href="https://example.com/link2"
                              //           target="_blank"
                              //           rel="noopener noreferrer"
                              //         >
                              //           <img
                              //             src="/images/new-item/buy-online-2.png"
                              //             alt=""
                              //           />
                              //         </a>
                              //       </div>
                              //       <div className="buy-online-grid-item">
                              //         <a
                              //           href="https://example.com/link3"
                              //           target="_blank"
                              //           rel="noopener noreferrer"
                              //         >
                              //           <img
                              //             src="/images/new-item/buy-online-3.png"
                              //             alt=""
                              //           />
                              //         </a>
                              //       </div>
                              //       <div className="buy-online-grid-item">
                              //         <a
                              //           href="https://example.com/link4"
                              //           target="_blank"
                              //           rel="noopener noreferrer"
                              //         >
                              //           <img
                              //             src="/images/new-item/buy-online-4.png"
                              //             alt=""
                              //           />
                              //         </a>
                              //       </div>
                              //       <div className="buy-online-grid-item">
                              //         <a
                              //           href="https://example.com/link5"
                              //           target="_blank"
                              //           rel="noopener noreferrer"
                              //         >
                              //           <img
                              //             src="/images/new-item/buy-online-5.png"
                              //             alt=""
                              //           />
                              //         </a>
                              //       </div>
                              //     </div>
                              //   </div>
                              // </>
                              <>
                                {/* Colours Section */}
                                {store?.colours && (
                                  <>
                                    <h5 className="tip-top-sub-topic">
                                      Available Colors
                                    </h5>
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "10px",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      {store?.colours.map((color, index) => (
                                        <div
                                          key={index}
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                            backgroundColor: color,
                                            borderRadius: "15%",
                                          }}
                                        ></div>
                                      ))}
                                    </div>
                                    <br />
                                  </>
                                )}

                                {/* Buy Online Section */}
                                {store?.buyOnlineLinks && (
                                  <>
                                    <h5 className="tip-top-sub-topic">
                                      Buy Online
                                    </h5>
                                    <div
                                      style={{
                                        marginLeft: "10px",
                                      }}
                                    >
                                      <div className="buy-online-grid-container">
                                        {store?.buyOnlineLinks.map(
                                          (link, index) => (
                                            <div
                                              key={index}
                                              className="buy-online-grid-item"
                                            >
                                              <a
                                                href={link.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                <img
                                                  src={link.image}
                                                  alt={`Buy online ${
                                                    index + 1
                                                  }`}
                                                />
                                              </a>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )}
                              </>
                            )}
                          </div>

                          <br />

                          <div>
                            <button
                              className="btn btn-secondary btn-lg"
                              style={{
                                backgroundColor: "#f4f4f4",
                                color: "#000",
                                padding: "15px",
                                paddingLeft: "20px",
                                paddingRight: "20px",
                                fontFamily: "AvenirLTStd-Book, sans-serif",
                                fontWeight: "700",
                                fontSize: "15px",
                                lineHeight: "20px",
                                textDecoration: "none",
                                border: "none",
                                marginLeft: "30px",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = "#000000";
                                e.target.style.color = "#ffffff";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = "#f4f4f4";
                                e.target.style.color = "#000000";
                              }}
                              onClick={toggleFormVisibility}
                            >
                              {showForm ? "Close Form" : "Send us your enquiry"}
                            </button>

                            {showForm && (
                              <div>
                                <Enquiry />
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    </table>
                    <div className="read-more-box">
                      <h3 className="read-more-h3">Related products</h3>
                      <div className="card-read-more-grid">
                        {cards.map((card, index) => (
                          <Card
                            key={index}
                            image={card.image}
                            itemName={card.itemName}
                            itemNumber={card.itemNumber}
                            button={card.button}
                            href={card.href}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </center>
      </div>

      <div className="store-mobile">
        <div
          style={{ marginLeft: "20px", marginRight: "20px", marginTop: "20px" }}
        >
          <ZoomImage
            imageUrl1={store?.image1 || store?.image}
            imageUrl2={store?.image2}
            imageUrl3={store?.image3}
            imageUrl4={store?.image4}
            imageUrl5={store?.image5}
            imageUrl6={store?.image6}
            itemNumber={store?.itemNumber}
          />
          <br />
          <h2
            className="read-more-topic"
            dangerouslySetInnerHTML={{ __html: store?.itemNumber }}
          ></h2>

          <div className="arrow-button-read-more">
            <a
              href={`/product/${
                store1?.id || storesData[storesData.length - 1].id
              }/`}
            >
              <button type="button" class="btn btn-custom btn-sm">
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
            </a>
            &nbsp;&nbsp;
            <a href={`/product/${store2?.id || storesData[0].id}/`}>
              <button type="button" class="btn btn-custom btn-sm">
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </a>
          </div>
          <p className="read-more-para">
            {store?.itemName === "Tip Top" && (
              <ul
                style={{
                  paddingLeft: "20px",
                  listStyleType: "disc",
                }}
              >
                {store?.itemDetails && <li>{store.itemDetails}</li>}
                {store?.itemDetails2 && <li>{store.itemDetails2}</li>}
                {store?.itemDetails3 && <li>{store.itemDetails3}</li>}
                {store?.itemDetails4 && <li>{store.itemDetails4}</li>}
                {store?.itemDetails5 && <li>{store.itemDetails5}</li>}
                {store?.itemDetails6 && <li>{store.itemDetails6}</li>}
                {store?.itemDetails7 && <li>{store.itemDetails7}</li>}
                {store?.itemDetails8 && <li>{store.itemDetails8}</li>}
                {store?.itemDetails9 && <li>{store.itemDetails9}</li>}
                {store?.itemDetails10 && <li>{store.itemDetails10}</li>}
              </ul>
            )}

            {store?.itemName !== "Tip Top" && (
              <>
                {store?.itemDetails}
                {store?.itemDetails2 && <br />}
                {store?.itemDetails2}
                {store?.itemDetails3 && <br />}
                {store?.itemDetails3}
                {store?.itemDetails4 && <br />}
                {store?.itemDetails4}
                {store?.itemDetails5 && <br />}
                {store?.itemDetails5}
                {store?.itemDetails6 && <br />}
                {store?.itemDetails6}
                {store?.itemDetails7 && <br />}
                {store?.itemDetails7}
                {store?.itemDetails8 && <br />}
                {store?.itemDetails8}
                {store?.itemDetails9 && <br />}
                {store?.itemDetails9}
                {store?.itemDetails10 && <br />}
                {store?.itemDetails10}
              </>
            )}
          </p>

          <div>
            {store?.itemName === "Tip Top" && (
              <>
                {/* Colours Section */}
                {store?.colours && (
                  <>
                    <h5 className="tip-top-sub-topic">Available Colors</h5>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginLeft: "10px",
                      }}
                    >
                      {store?.colours.map((color, index) => (
                        <div
                          key={index}
                          style={{
                            width: "40px",
                            height: "40px",
                            backgroundColor: color,
                            borderRadius: "15%",
                          }}
                        ></div>
                      ))}
                    </div>
                    <br />
                  </>
                )}

                {/* Buy Online Section */}
                {store?.buyOnlineLinks && (
                  <>
                    <h5 className="tip-top-sub-topic">Buy Online</h5>
                    <div
                      style={{
                        marginLeft: "10px",
                      }}
                    >
                      <div className="buy-online-grid-container">
                        {store?.buyOnlineLinks.map((link, index) => (
                          <div key={index} className="buy-online-grid-item">
                            <a
                              href={link.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={link.image}
                                alt={`Buy online ${index + 1}`}
                              />
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
          <br />
          <div>
            <button
              className="btn btn-secondary btn-lg"
              style={{
                backgroundColor: "#f4f4f4",
                color: "#000",
                padding: "15px",
                fontFamily: "AvenirLTStd-Book, sans-serif",
                fontWeight: "700",
                fontSize: "15px",
                lineHeight: "20px",
                textDecoration: "none",
                border: "none",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#000000";
                e.target.style.color = "#ffffff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#f4f4f4";
                e.target.style.color = "#000000";
              }}
              onClick={toggleFormVisibility}
            >
              {showForm ? "Close Form" : "Send us your enquiry"}
            </button>

            {showForm && (
              <div
                style={{
                  marginTop: "-25px",
                  zIndex: "-1",
                }}
              >
                <Enquiry />
              </div>
            )}
          </div>

          <div style={{ marginTop: "40px" }}>
            <div className="read-more-box">
              <h3 className="read-more-h3">Related products</h3>
              <br />
              <div className="card-read-more-grid">
                {cards.map((card, index) => (
                  <Card
                    key={index}
                    image={card.image}
                    itemName={card.itemName}
                    itemNumber={card.itemNumber}
                    button={card.button}
                    href={card.href}
                  />
                ))}
              </div>
            </div>
          </div>

          <div style={{ marginTop: "70px", marginBottom: "40px" }}>
            <Sidebar />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
